import styled from 'styled-components'

const PANEL_DARK = '#161e24'
const PANEL_DARK_TOP = '#2c3843'

export const StyledIntro = styled.p`
  margin: 0 0 var(--m-spacing-2);
  font-family: var(--m-font-family-default);
  font-size: 13.5px;
  line-height: 150%;
  color: rgb(var(--m-color-text-placeholder));
`

export const StyledOption = styled.section`
  padding: 22px 0;
  border-bottom: var(--m-border-thin) solid rgb(var(--m-color-divider));

  &:last-of-type {
    border-bottom: 0;
    padding-bottom: var(--m-spacing-1);
  }
`

export const StyledOptionHead = styled.div`
  display: flex;
  align-items: center;
  gap: var(--m-spacing-3);
  margin-bottom: var(--m-spacing-3);
`

export const StyledOptionTile = styled.span`
  flex: none;
  width: 36px;
  height: 36px;
  border-radius: 11px;
  display: grid;
  place-items: center;
  background: linear-gradient(160deg, ${PANEL_DARK_TOP} 0%, ${PANEL_DARK} 100%);

  img,
  svg {
    width: 20px;
    height: 20px;
    display: block;
    object-fit: contain;
  }
`

export const StyledOptionName = styled.span`
  display: block;
  height: 15px;
  color: rgb(var(--m-color-text-primary));

  svg {
    height: 100%;
    width: auto;
    display: block;
  }
`

export const StyledOptionTitle = styled.p`
  margin: 0;
  font-family: var(--m-font-family-title);
  font-size: 15px;
  font-weight: var(--m-font-weight-bold);
  color: rgb(var(--m-color-text-primary));
`

export const StyledOptionDetails = styled.dl`
  margin: 0;
  display: grid;
  grid-template-columns: 88px 1fr;
  gap: 9px var(--m-spacing-4);
  font-family: var(--m-font-family-default);
  font-size: 13.5px;
  line-height: 155%;

  dt {
    padding-top: 3px;
    font-family: var(--m-font-family-title);
    font-size: 10.5px;
    font-weight: var(--m-font-weight-medium);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgb(var(--m-color-text-placeholder));
  }

  dd {
    margin: 0;
    color: rgb(var(--m-color-text-secondary));
  }

  @media screen and (max-width: 560px) {
    grid-template-columns: 1fr;
    gap: 3px;

    dt {
      padding-top: var(--m-spacing-2);
    }
  }
`

export const StyledFootnote = styled.p`
  margin: var(--m-spacing-4) 0 0;
  padding-top: var(--m-spacing-4);
  border-top: var(--m-border-thin) solid rgb(var(--m-color-divider));
  font-family: var(--m-font-family-default);
  font-size: var(--m-font-size-3);
  line-height: 150%;
  color: rgb(var(--m-color-text-placeholder));
`
